<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <div class="d-flex align-items-center gap-2">
          <div class="modal-title" i18n>Add Rental</div>
          <app-page-help articleId="-" videoId="-"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <button (click)="close()" type="button" class="btn btn-outline-light">
          <span class="far fa-times"></span>
          <ng-container i18n>Cancel</ng-container>
        </button>
        <button (click)="save(form)" type="button" class="btn btn-secondary-info">
          <span class="cs-icon cs-icon-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" class="container-box p-3">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <h6 class="section-title text-uppercase" i18n>Rental Information</h6>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    type="text"
                    formControlName="name"
                    matInput
                    required
                    i18n-placeholder
                    placeholder="Name"
                    (input)="onNameChange($event.target.value)"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
                    <ng-container i18n>Name is required</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('allNumbers')">
                    <ng-container i18n>Name cannot be numbers alone.</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('allSpaces')">
                    <ng-container i18n>Name cannot be spaces alone.</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
                    <ng-container i18n>Name must be at least 2 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
                    <ng-container i18n>Name must be at most 140 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('name').hasError('nameTaken')">
                    <ng-container i18n>Name is already in use by another rental.</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    type="text"
                    formControlName="nickname"
                    matInput
                    i18n-placeholder
                    placeholder="Nickname"
                    autocomplete="off"
                  />
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-6">
                    <app-phone-number-input
                      [ctrl]="form.get('phone')"
                      i18n-placeholder
                      placeholder="Phone"
                    ></app-phone-number-input>
                  </div>
                  <div class="col-sm-6">
                    <app-currency-select [ctrl]="form.get('currency')"></app-currency-select>
                    <mat-error *ngIf="form.get('currency').touched && form.get('currency').hasError('required')" i18n>
                      Currency is required
                    </mat-error>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    type="email"
                    formControlName="email"
                    matInput
                    required
                    i18n-placeholder
                    placeholder="AdvanceCM Email"
                    autocomplete="off"
                  />
                  <span *ngIf="form.get('name').value.length > 0 || form.get('email').value.length > 0" matSuffix
                    >@{{ subDomain }}</span
                  >
                  <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')">
                    <ng-container i18n>Email is required</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('minlength')">
                    <ng-container i18n>Email handle must be at least 3 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('email').hasError('emailTaken')">
                    <ng-container i18n>Email is already in use by another rental.</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('email').hasError('rentalEmail')">
                    <ng-container i18n>Email is invalid</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    type="email"
                    formControlName="registration"
                    matInput
                    i18n-placeholder
                    placeholder="Registration Number"
                    autocomplete="off"
                  />
                </mat-form-field2>
              </div>
              <div class="col-md-12 colors-container">
                <h6 class="manual-label" i18n>Calendar Colors</h6>
                <app-color-boxes [ctrl]="form.get('color')"></app-color-boxes>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row" formGroupName="address">
              <div class="col-md-12">
                <h6 class="section-title text-uppercase" i18n>Rental Location</h6>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    appGooglePlaces
                    (onAddressChange)="onPlaceChange($event)"
                    autocomplete="address-1"
                    type="text"
                    formControlName="address"
                    matInput
                    i18n-placeholder
                    placeholder="Address"
                  />
                  <mat-error *ngIf="addressForm.get('address').hasError('minlength')">
                    <ng-container i18n>Address must be at least 2 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('address').hasError('maxlength')">
                    <ng-container i18n>Address must be at most 140 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('address').hasError('allSpaces')">
                    <ng-container i18n>Address cannot be spaces alone.</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    appGooglePlaces
                    (onAddressChange)="onCityChange($event)"
                    type="text"
                    formControlName="city"
                    matInput
                    required
                    i18n-placeholder
                    placeholder="City"
                  />
                  <mat-error
                    *ngIf="addressForm.get('city').touched && addressForm.get('city').hasError('required')"
                    i18n
                  >
                    City is required
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('city').hasError('minlength')" i18n>
                    City must be at least 2 characters long
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('city').hasError('maxlength')" i18n>
                    City must be at most 50 characters long
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('city').hasError('allSpaces')" i18n>
                    City cannot be spaces alone
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input
                    type="text"
                    formControlName="state"
                    matInput
                    i18n-placeholder
                    placeholder="State / Province / Region"
                  />
                  <mat-error *ngIf="addressForm.get('state').hasError('minlength')">
                    <ng-container i18n>Value must be at least 2 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('state').hasError('maxlength')">
                    <ng-container i18n>Value must be at most 50 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('state').hasError('allSpaces')">
                    <ng-container i18n>State cannot be spaces alone.</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <app-country-select
                  [nameCtrl]="addressForm.get('country')"
                  [codeCtrl]="addressForm.get('country_code')"
                  [showBlankItem]="false"
                ></app-country-select>
              </div>
              <div class="col-md-12">
                <mat-form-field2 class="mat-block">
                  <input type="text" formControlName="zip" matInput i18n-placeholder placeholder="Postal Code" />
                  <mat-error *ngIf="addressForm.get('zip').hasError('minlength')">
                    <ng-container i18n>Value must be at least 2 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('zip').hasError('maxlength')">
                    <ng-container i18n>Value must be at most 50 characters long</ng-container>
                  </mat-error>
                  <mat-error *ngIf="addressForm.get('zip').hasError('allSpaces')">
                    <ng-container i18n>Postal code cannot be spaces alone.</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="alert alert-secondary-info mt20">
        <i class="fal fa-info-circle alert-icon"></i>
        <div class="alert-content">
          <ng-container i18n>Want to change your AdvanceCM domain? Please go to your</ng-container>
          <a (click)="goToAccountSettings()"
            ><b> <ng-container i18n>Account Settings</ng-container></b></a
          ><br />
          <ng-container i18n
            >If you've already connected your Airbnb account you can import your rentals into AdvanceCM. Check out your
            channel</ng-container
          >
          <a (click)="goToConnections()"
            ><b> <ng-container i18n>Connection Details</ng-container></b></a
          >.
        </div>
      </div>
    </div>
  </div>
</div>
